import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'
import { useState } from 'react'

const VendorCode = () => {

    const [value, setValue] = useState('')

    return (
        <div>
            <FormControl size="small" fullWidth>
                <InputLabel>Vendor Code</InputLabel>
                <Select
                    label="Vendor Code"
                    value={value}
                    onChange={(event) => {
                        setValue(event.target.value);
                    }}
                >
                    <MenuItem value={''}>
                        None
                    </MenuItem>
                </Select>
            </FormControl>
        </div>
    )
}

export default VendorCode